export enum MobileOS {
	IOS = 'iOS',
	ANDROID = 'Android',
	NULL = '',
}
